export const langMap = {
  pt: {
    PayMethod: 'Método de pagamento',
    ViewMore: 'Ver mais'
  },
  zh: {
    PayMethod: '支付方式',
    ViewMore: '查看更多'
  },
  en: {
    PayMethod: 'Payment method',
    ViewMore: 'View more'
  },
  ar: {
    PayMethod: 'طريقة الدفع او السداد',
    ViewMore: 'فحص المزيد'
  },
  bn: {
    PayMethod: 'মূল্যপরিশোধ পদ্ধতি',
    ViewMore: 'আরও দেখুন'
  },
  es: {
    PayMethod: 'método de pago',
    ViewMore: 'Ver más'
  },
  id: {
    PayMethod: 'Cara Pembayaran',
    ViewMore: 'Lihat lebih banyak'
  },
  th: {
    PayMethod: 'วิธีการชำระเงิน',
    ViewMore: 'View more'
  },
  tr: {
    PayMethod: 'Ödeme şekli',
    ViewMore: 'Daha fazla görüntüle'
  },
  ur: {
    PayMethod: 'ادائیگی کا طریقہ',
    ViewMore: 'مزید دیکھیں'
  },
  in: {
    PayMethod: 'Cara Pembayaran',
    ViewMore: 'Lihat lebih banyak'
  }
};